import { useMemo } from 'react';
import { Helmet } from 'react-helmet';

const appName = 'Labscoop';
const appDescription =
  'Supercharge your lab with a team-centric marketplace that streamlines supply shopping, ordering, inventory, and requisitions. Trusted by over 2,000+ Organizations.';

const MetaProvider = (props) => {
  const { children, meta } = props;

  const canonical = useMemo(() => {
    if (meta?.canonical) {
      return meta.canonical;
    }
    return [window.location.origin, window.location.pathname]
      .filter(Boolean)
      .join('');
  }, [meta]);

  const title = useMemo(() => {
    const titles = Array.isArray(meta?.title)
      ? meta.title
      : [meta?.title].filter(Boolean);
    return [appName, ...titles].filter(Boolean).join(' | ');
  }, [meta]);

  const description = meta?.description || appDescription;

  const snippet = useMemo(() => {
    if (!meta?.snippet) {
      return null;
    }
    return meta?.snippet;
  }, [meta]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={description} />

        {!!snippet && (
          <script type="application/ld+json">
            {JSON.stringify(snippet, null, 2)}
          </script>
        )}
      </Helmet>

      {children}
    </>
  );
};

export default MetaProvider;
